<template>
    <div>
        <p class="label" v-if="!hideLabel">{{ label }}</p>
        <MultiplePickerInput :value="value" @input="onInput" :items="items" :loading="loading" v-bind="$attrs" />
    </div>
</template>

<script>
  import MultiplePickerInput from '@/components/inputs/MultiplePickerInput.vue';
  import TrainingTypeService from '@/services/training-type.service.js';

  export default {
    name: "TrainingTypeMultiplePickerInput",
    components: {
      MultiplePickerInput,
    },
    props: {
      value: {},
      label: { type: String, default: 'Type(s) de formation souhaité(s) à poursuivre de études ?'},
      hideLabel: {type: Boolean, default: false}
    },
    data() {
      return {
        items: [],
        loading: false,
      }
    },
    created() {
      this.loadListItem();
    },
    methods: {
      loadListItem() {
        const _this = this;

        TrainingTypeService.getList()
          .then(({data}) => {
            _this.items = data;
          });
      },
      onInput(event) {
        this.$emit('input', event);
      }
    },
  }
</script>

<style scoped>

</style>
